import axios from "axios";

export const useApi = (token?: string) => {
  const config = useRuntimeConfig();
  const { logout } = useUsuarioStore();

  const instance = axios.create({
    baseURL: config.public.apiBase,
    headers: { "x-api-key": config.public.key, Authorization: process.client ? `Bearer ${token ? token : useUsuarioStore().$state.token ?? ""}` : "" }
  });

  instance.interceptors.response.use(response => {
    return response;
  }, err => {
    if (err.response.status === 401 )
    {
      logout();
      navigateTo('/autenticacao/login');

      return Promise.reject(err);
    }

    return Promise.reject(err);
  });

  return instance;
};